import { useEffect, useState } from 'preact/hooks';
import { useLocation } from 'wouter-preact';
import { Button } from '../ui/Button.jsx';
import { Field } from '../ui/Field.jsx';
import { Sheet } from '../ui/Sheet.jsx';
import { useDb, useSync } from '../contexts.jsx';
import { enqueue } from '../store/outbox.js';

export function Handover({ familyKey }) {
  const { db } = useDb();
  const sync = useSync();
  const [, setLoc] = useLocation();
  const [state, setState] = useState(null);
  const [subFor, setSubFor] = useState(false);
  const [subMemberId, setSubMemberId] = useState('');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      const family = await db.get('families', familyKey);
      const members = await db.getAllFromIndex('people', 'by_family_key', familyKey);
      setState({ family, members });
      setSubMemberId(family?.collector_member_id || '');
    })();
  }, [db, familyKey]);

  if (!state?.family) return null;
  const { family, members } = state;
  const picked = members.find((m) => m.member_id === subMemberId) || {};
  const substitute = subFor && subMemberId && subMemberId !== family.collector_member_id;

  async function confirm() {
    setBusy(true);
    await enqueue(db, {
      client_id: crypto.randomUUID(),
      family_key: familyKey,
      collected_member_id: picked.member_id || family.collector_member_id,
      collected_name: picked.name || family.collector_name,
      designated_name: family.collector_name,
      substitute,
      reason: substitute ? reason.trim() : null,
      device: navigator.userAgent,
    });
    sync.kickNow?.();
    setLoc(`/done/${encodeURIComponent(familyKey)}`);
  }

  return (
    <>
      <Sheet>
        <div style={{ fontSize: 18, fontWeight: 600 }}>{family.name}</div>
        <div>
          Designated: <b>{family.collector_name}</b>
        </div>
      </Sheet>
      <Sheet>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input
            type="checkbox"
            checked={subFor}
            onChange={(e) => setSubFor(e.currentTarget.checked)}
          />
          Someone else is collecting
        </label>
        {subFor && (
          <>
            <Field label="Who is collecting">
              <select value={subMemberId} onChange={(e) => setSubMemberId(e.currentTarget.value)}>
                {members.map((m) => (
                  <option key={m.member_id} value={m.member_id}>
                    {m.name}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Reason (short)">
              <input
                value={reason}
                onInput={(e) => setReason(e.currentTarget.value)}
                placeholder="e.g. mother is sick"
              />
            </Field>
          </>
        )}
      </Sheet>
      <Button
        variant="primary"
        block
        onClick={confirm}
        disabled={busy || (subFor && !reason.trim())}
      >
        Confirm Handover
      </Button>
    </>
  );
}
